// base_file_upload.js
import React, { useMemo, useState } from "react";
import { CrmFileUpload1_1, toast } from "../ui/ot"
import { FileImage, FileVideo, Music, FileText, Loader2 } from "lucide-react";

const CrmFileUpload1 = ({
    showComponent = ["CrmFileUpload1_1"],
    files = [],
    CrmFileUpload1_1Props = {
        types: ["image", "video", "audio", "document"],
        uploadConfig: {
            image: {
                key: "image",
                label: "上傳圖片",
                icon: FileImage,
                preview: "image", // 顯示縮圖
                miniBg: "bg-white",
                miniIconColor: "",
            },
            video: {
                key: "video",
                label: "上傳影片",
                icon: FileVideo,
                preview: "icon", // 小圖示
                miniBg: "bg-blue-50",
                miniIconColor: "text-blue-600",
            },
            audio: {
                key: "audio",
                label: "上傳音檔",
                icon: Music,
                preview: "icon",
                miniBg: "bg-green-50",
                miniIconColor: "text-green-600",
            },
            document: {
                key: "document",
                label: "上傳文件",
                icon: FileText,
                preview: "icon",
                miniBg: "bg-orange-50",
                miniIconColor: "text-orange-600",
            },
        }
    },
    title = "上傳參考資料",
    description = "您可以上傳圖片、影片、音檔或文件作為參考資料。",
    watingDescription = "正在上傳檔案...",

}) => {
    const [uploadedRequirementFiles, setUploadedRequirementFiles] = useState([])
    const [isUploading, setIsUploading] = useState(false)

    // 依類型分組，避免多次 filter
    const filesByType = useMemo(() => {
        const map = { image: [], video: [], audio: [], document: [] };
        for (const f of files) {
            if (map[f.fileType]) map[f.fileType].push(f);
        }
        return map;
    }, [files]);

    const handleUpload = (typeKey) => {
        handleRequirementFileUpload?.(typeKey);
    };

    // 處理檔案上傳
    const handleRequirementFileUpload = (fileType) => {
        setIsUploading(true)

        // 模擬檔案上傳
        setTimeout(() => {
            const newFile = {
                id: `file-${Date.now()}`,
                type: fileType,
                name: `${fileType}-${Math.floor(Math.random() * 1000)}.${fileType === "document" ? "pdf" : fileType === "image" ? "jpg" : fileType === "video" ? "mp4" : "mp3"}`,
                // 使用靜態路徑替代動態生成的 blob URL
                url: `/placeholder.svg?height=100&width=100&query=${fileType}`,
                fileType: fileType,
            }

            setUploadedRequirementFiles([...uploadedRequirementFiles, newFile])
            setIsUploading(false)

            toast({
                title: "檔案上傳成功",
                description: `已成功上傳 ${newFile.name}`,
            })
        }, 1500)
    }


    return (<>
        {
            showComponent.includes("CrmFileUpload1_1") && (
                <div className="space-y-4">
                    <div>
                        <h4 className="text-md font-medium text-teal-800 mb-2">{title}</h4>
                        <p className="mb-4 text-sm text-teal-700">{description}</p>

                        <div className="grid grid-cols-2 gap-3 mb-4">
                            {CrmFileUpload1_1Props?.types.map((t) => (
                                <CrmFileUpload1_1
                                    showComponent={['BaseFileUpload1']}
                                    BaseFileUpload1Porps={
                                        [
                                            {
                                                key: t,
                                                mediaType: t,
                                                title: CrmFileUpload1_1Props?.['uploadConfig']?.[t]?.['label'],
                                                mediaIcon: CrmFileUpload1_1Props?.['uploadConfig']?.[t]?.['icon'],
                                                files: uploadedRequirementFiles?.filter(_ => _?.fileType == t) || [],
                                                disabled: isUploading,
                                                uploadConfig: CrmFileUpload1_1Props?.['uploadConfig'],
                                                onClick: handleUpload,
                                            }
                                        ]
                                    }
                                />
                            ))}
                        </div>

                        {isUploading && (
                            <div className="flex items-center justify-center p-3 border border-dashed rounded-md bg-gray-50">
                                <Loader2 className="h-4 w-4 animate-spin mr-2 text-teal-600" />
                                <span className="text-sm text-gray-600">{watingDescription}</span>
                            </div>
                        )}
                    </div>
                </div>
            )
        }
    </>)
}

export default CrmFileUpload1
